
import VerRegistros from "../../components/admin/VerRegistros.vue";
import ModificarDispositivos from "../../components/admin/ModificarDispositivos.vue";
import vhero from "../../components/shared/VHero.vue";
import Vue from "vue";
import es from "date-fns/locale/es";

export default Vue.extend({
	components: { vhero, ModificarDispositivos, VerRegistros },
	mounted() {
		this.cargarDatos();
	},
	data() {
		return {
			es: es,
			usuarios: [] as Array<{ id: string; nombre: string; email: string; estado: string }>,
			filtroDesde: null as Date | null,
			filtroHasta: null as Date | null,
			modalDispositivos: {
				active: false,
				userId: ""
			},
			usuarioSeleccionado: "",
			modalRegistros: {
				active: false,
				userId: ""
			},
			esCargado: false,
			empresaSeleccionada: 'softcom'
		};
	},
	methods: {
		activar(id: string) {
			const datos = {
				id,
				email: ""
			};

			this.$http
				.put("Usuario/activar", datos, {
					headers: {
						Authorization: `Bearer ${this.$store.state.jwt}`
					}
				})
				.then(() => {
					this.$toast.open({
						message: "Activada correctamente",
						type: "is-success",
						position: "is-bottom"
					});

					this.cargarDatos();
				})
				.catch(() => {
					this.$toast.open({
						message: "Error al activar",
						type: "is-danger",
						position: "is-bottom"
					});
				});
		},
		desactivar(id: string) {
			const datos = {
				id,
				email: ""
			};

			this.$http
				.put("Usuario/desactivar", datos, {
					headers: {
						Authorization: `Bearer ${this.$store.state.jwt}`
					}
				})
				.then(() => {
					this.$toast.open({
						message: "Desactivada correctamente",
						type: "is-success",
						position: "is-bottom"
					});

					this.cargarDatos();
				})
				.catch(() => {
					this.$toast.open({
						message: "Error al desactivar",
						type: "is-danger",
						position: "is-bottom"
					});
				});
		},
		cargarDatos() {
			this.$http
				.get("Usuario", {
					headers: {
						Authorization: `Bearer ${this.$store.state.jwt}`
					}
				})
				.then(res => {
					this.usuarios = res.data.usuariosDatos;
					this.esCargado = true;
				})
				.catch(() => {
					this.$router.push("/");
					this.esCargado = true;
				});
		},
		descargarExcel() {
			this.$http.get("Informe", {
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${this.$store.state.jwt}`
				}
			}).then(res => {
				const d = new Date()
				const formatDate = d.getDate() + "-" + d.getMonth() + "-" + d.getFullYear() + "-" + d.getHours() + "-" + d.getMinutes()
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'informe-completo_' + formatDate + '.xlsx');
				link.click();
			})
		},
		descargarExcelFiltrado() {
			let url = "Informe/InformeFiltrado";

			const params: any = {};

			// Usuario seleccionado
			if (this.usuarioSeleccionado) {
				const usuario = this.usuarios.find(u => u.id === this.usuarioSeleccionado);
				if (usuario) {
					params.usuarioEmail = usuario.email;
				}
			}

			// Fechas seleccionadas
			if (this.filtroDesde) {
				params.fechaInicio = this.filtroDesde.toLocaleDateString('en-CA')
			}
			if (this.filtroHasta) {
				params.fechaFin = this.filtroHasta.toLocaleDateString('en-CA')
			}

			this.$http.get(url, {
				params,
				responseType: "blob",
				headers: {
					Authorization: `Bearer ${this.$store.state.jwt}`
				}
			}).then(res => {
				const d = new Date();
				const formatDate = `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}-${d.getHours()}-${d.getMinutes()}`;
				const blob = new Blob([res.data]);
				const link = document.createElement("a");
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute("download", "informe-filtrado_" + formatDate + ".xlsx");
				link.click();
			});
		}

	}
});
